import Alpine from "alpinejs";

import collapse from "@alpinejs/collapse";

import anchor from "@alpinejs/anchor";

import morph from "@alpinejs/morph";

import focus from "@alpinejs/focus";

import intersect from "@alpinejs/intersect";

import mask from "@alpinejs/mask";

import persist from "@alpinejs/persist";

import sort from "@alpinejs/sort";

import htmx from "htmx.org";

import { initAlpine } from "./alpine";

import { initHTMX } from "./htmx";

import { initVanilla } from "./vanilla";

import { initOffersChart } from "./vanilla/chartJs/offers";
import { handleAnyClick } from "./vanilla/features/filters";

window.handleAnyClick = handleAnyClick;
window.initOffersChart = initOffersChart;

// -----------------------------------------------------------------------------
// HTMX
// -----------------------------------------------------------------------------

window.Alpine = Alpine;

window.htmx = htmx;

import "htmx-ext-alpine-morph";

import "htmx-ext-loading-states";

// -----------------------------------------------------------------------------
// ALPINE PLUGINS
// -----------------------------------------------------------------------------

Alpine.plugin(collapse);

Alpine.plugin(focus);

Alpine.plugin(anchor);

Alpine.plugin(morph);

Alpine.plugin(mask);

Alpine.plugin(intersect);

Alpine.plugin(sort);

Alpine.plugin(persist);

// -----------------------------------------------------------------------------
// INITIALIZE ALPINE REGISTRARS
// -----------------------------------------------------------------------------

initAlpine(Alpine);

// -----------------------------------------------------------------------------
// START ALPINE
// -----------------------------------------------------------------------------

Alpine.start();

// -----------------------------------------------------------------------------
// HTMX + ALPINE
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// HTMX
// -----------------------------------------------------------------------------

initHTMX();

// -----------------------------------------------------------------------------
// VANILLA
// -----------------------------------------------------------------------------

initVanilla();
